import Vue from 'vue'
import VueYouTubeEmbed from 'vue-youtube-embed'
import VueTouch from 'vue-touch'
import Vuelidate from 'vuelidate'
import VuelidateErrorExtractor, { templates } from 'vuelidate-error-extractor'
import FormField from '@/components/core/FormField'
import validations from '@/bootstrap/validations'
import VModal from 'vue-js-modal'
import { Notifications } from '@/services/Notifications'
import router from '@/router'
import VueMeta from 'vue-meta'
import VueMultianalytics from 'vue-multianalytics'

Vue.use(VueYouTubeEmbed, { global: false })
Vue.use(VueTouch, { name: 'v-touch' })
Vue.use(Vuelidate)
Vue.use(VuelidateErrorExtractor, {
  messages: validations,
  name: 'FormField',
  attributes: {
    name: 'Имена',
    first_name: 'Име',
    last_name: 'Фамилия',
    email: 'Имейл',
    email_confirm: 'Потвърди Имейл',
    phone: 'Телефон',
    password: 'Парола',
    password_confirmation: 'Потвърди Парола',
    over_18: 'Навършени 18 години',
    terms: 'Условия за ползване',
    topic: 'Тема',
    message: 'Съобщение',
    ticket: 'Предположение',
    card: 'Талон',
    number: 'Код',
    value: 'Предположение',
    keep_ticket: 'Запази касов бон',
    gdpr: 'Защита на личните данни',
    ref_code: 'Референтен код за отстъпка'
  }
})

Vue.component('FormField', FormField)
Vue.component('FormWrapper', templates.FormWrapper)
Vue.component('BaseMultiErrorExtractor', templates.multiErrorExtractor.baseMultiErrorExtractor)

Vue.use(VModal, { componentName: 'v-modal' })
Vue.prototype.$notify = Notifications

Vue.use(VueMultianalytics, {
  modules: {
    ga: {
      appName: 'MPS Expert',
      appVersion: '1.0.0',
      trackingId: 'UA-23958383-7'
    },
    facebook: {
      token: '361003421236691'
    }
  },
  routing: {
    vueRouter: router
  }
})

Vue.use(VueMeta, {
  keyName: 'head'
})
